import { dateToStr } from './DateUtils';

export const tooltipDelay = 1000;
export const pageSizes = [5, 10, 20, 30, 50];
export const defaultGridOptions = {
  localization: {
    header: {
      actions: 'Acciones',
    },
    pagination: {
      labelDisplayedRows: '{from}-{to} de {count}',
      labelRowsSelect: 'registros',
      labelRowsPerPage: 'Filas por página:',
      firstAriaLabel: 'Primera página',
      firstTooltip: 'Primera página',
      previousAriaLabel: 'Página anterior',
      previousTooltip: 'Página anterior',
      nextAriaLabel: 'Página siguiente',
      nextTooltip: 'Página siguiente',
      lastAriaLabel: 'Última página',
      lastTooltip: 'Última página',
    },
    body: {
      emptyDataSourceMessage: 'No hay registros para mostrar',
    },
  },
  options: {
    padding: 'dense',
    sorting: false,
    draggable: false,
    showTitle: false,
    toolbar: false,
    pageSize: pageSizes[0],
    pageSizeOptions: pageSizes,
    headerStyle: {
      // transform: 'translateX(18px)',
      fontWeight: 'bold',
      // fontSize: 11,
      // lineHeight: 'normal',
      whiteSpace: 'nowrap',
      borderLeft: '1px solid rgba(0,0,0,.05)',
      // paddingRight: 0,
    },
    cellStyle: {
      padding: '3px 15px 3px 15px',
      borderLeft: '1px solid rgba(0,0,0,.05)',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '30em',
      // fontSize: 11,
    },
  },
};

export const parseCLDR26 = num => {
  if (!num && num!==0) return '';

  const localeOptions = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  const localeNum = Number.isInteger(num) ? num.toLocaleString('es-AR') : num.toLocaleString('es-AR', localeOptions);

  return localeNum.split(',')[0].length === 4 ? `${localeNum[0]}.${localeNum.slice(1)}` : localeNum;
};

export const gridColDefs = colDefs => {
  return colDefs.map(def => {
    let customization = {};

    if (def.brakeWhiteSpaceHeader) {
      customization = { ...customization, headerStyle: { ...defaultGridOptions.options.headerStyle, whiteSpace: 'unset' } };
      delete def.brakeWhiteSpaceHeader;
    }

    if (def.currencyRef) {
      const currencyField = def.currencyRef;
      customization = {
        ...customization,
        cellStyle: { ...defaultGridOptions.options.cellStyle, textAlign: 'right' },
        render: rowData => (rowData[currencyField] ? `${rowData[currencyField]} ${parseCLDR26(rowData[def.field])}` : ''),
      };

      delete def.currencyRef;
    }

    if (def.valueType === 'date') {
      customization = { ...customization, render: rowData => (rowData[def.field] ? dateToStr(rowData[def.field]) : '') };
      delete def.valueType;
    }

    if (def.valueType === 'numeric') {
      customization = {
        ...customization,
        cellStyle: { ...defaultGridOptions.options.cellStyle, textAlign: 'right' },
        render: rowData => (rowData[def.field] ? parseCLDR26(rowData[def.field]) : ''),
      };

      delete def.valueType;
    }

    if (def.valueType === 'id') {
      customization = {
        ...customization,
        cellStyle: { ...defaultGridOptions.options.cellStyle, textAlign: 'center' },
        render: rowData => (rowData[def.field] ? parseCLDR26(rowData[def.field]) : ''),
      };

      delete def.valueType;
    }

    if (def.valueType === 'icon') {
      customization = {
        ...customization,
        cellStyle: { ...defaultGridOptions.options.cellStyle, textAlign: 'center', padding: 0 },
      };

      delete def.valueType;
    }

    if (def.valueRender) {
      const valueRender = def.valueRender;
      customization = { ...customization, render: rowData => valueRender(rowData[def.field], rowData) };

      delete def.valueRender;
    }

    return { ...def, ...customization };
  });
};

export const useGridColDefs = colDefs => {
  return gridColDefs(colDefs);
};
